export default "__VITE_ASSET__BWr$G45y__"